<template>
	<CRow>
        <div>
            <CModal
                title="Detail"
                size="lg"
                :show.sync="largeModal"
                :no-close-on-backdrop="true"
                color="primary"
            >
            <CForm novalidate @submit.prevent="onSubmit">
                <table class="table table-bordered" v-if="mod">
                    <!-- Link row -->
                    <tr v-if="detail.link">
                        <td>Link</td>
                        <td>
                        <a
                            :href="formatLink(detail.link)"
                            target="_blank"
                            rel="noopener noreferrer"
                            @click.stop
                        >
                            Link
                        </a>
                        </td>
                    </tr>

                    <!-- Download row -->
                    <tr v-else>
                        <td>Download</td>
                        <td>
                        <a :href="detail.url" download>
                            Download file
                        </a>
                        </td>
                    </tr>

                    <!-- Status row -->
                    <tr>
                        <td>Status</td>
                        <td>
                            <v-select v-model="detail.status" :options="statusOptions"/>
                        </td>
                    </tr>
                    <tr v-if="detail.status.id == 1">
                        <td>Select Scholarship</td>
                        <td>
                            <v-select
                                :options="scholarships"
                                v-model="detail.selectedScholarship"
                            ></v-select>
                        </td>
                    </tr>
                    <tr v-if="detail.status.id == 2">
                        <td>Remarks</td>
                        <td>
                            <input type="text" v-model="detail.remarks" class="form-control" placeholder="Enter remarks"/>
                        </td>
                    </tr>
                    <CButton
                        v-if="detail.status.id != 0"
                        type="submit"
                        size="sm"
                        color="primary"
                        :disabled="submitted"
                    >
                    <CIcon name="cil-check-circle"/>
                    {{ $lang.buttons.general.crud.submit }}
                    </CButton>
                </table>
                <table class="table table-bordered" v-else>
                    <!-- Link row -->
                    <tr v-if="detail.link">
                        <td>Link</td>
                        <td>
                        <a
                            :href="formatLink(detail.link)"
                            target="_blank"
                            rel="noopener noreferrer"
                            @click.stop
                        >
                            Link
                        </a>
                        </td>
                    </tr>

                    <!-- Download row -->
                    <tr v-else>
                        <td>Download</td>
                        <td>
                        <a :href="detail.url" download>
                            Download file
                        </a>
                        </td>
                    </tr>

                    <!-- Status row -->
                    <tr>
                        <td>Status</td>
                        <td>
                            {{ detail.status.label }}
                        </td>
                    </tr>
                    <tr v-if="detail.status.id == 1">
                        <td>Select Scholarship</td>
                        <td>
                            {{ detail.selectedScholarship.label }}
                        </td>
                    </tr>
                    <tr v-if="detail.status.id == 2">
                        <td>Remarks</td>
                        <td>
                            {{ detail.remarks }}
                        </td>
                    </tr>
                </table>
                </CForm>
                <template #footer style="display: none">
                    <CButton @click="darkModal = false" color="danger" style="display: none"
                    >Discard
                    </CButton
                    >
                    <CButton
                        @click="darkModal = false"
                        color="success"
                        style="display: none"
                    >Accept
                    </CButton>
                </template>
            </CModal>
        </div>
		<CCol col="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}
            </CAlert>
        </CCol>
		<CCol col="12">
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Scholarship Upload</strong>
						</CCol>
					
					</div>
				</CCardHeader>
				<CCardBody>
					<v-server-table url="scholarship/attachment/list" :columns="columns" :options="options" :data="data" ref="myTable">
                        <template #user="data">
                            {{ data.row.user.name }}
                        </template>
						<template #actions="data">
                            <CButton
                                color="primary"
                                v-on:click="viewContact(data.row)"
                            >
                                <i class="fas fa-eye"></i>
                            </CButton>
						</template>
					</v-server-table>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import { scholarship } from "/src/store/url.js";
import store from "../../store/store";
import { Mixin } from "/src/mixins/index.js";
import VueJsonToCsv from "vue-json-to-csv";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(ServerTable, {}, false);
Vue.use(VueSweetalert2);
export default {
	name: "Scholarship",
	mixins: [Mixin],
	components: {
		VueJsonToCsv
	},
	data() {
		return {
			self: this,
            upload : {},
            mod : true,
            detail: {
                link: '',
                id: '',
                url: '',
                status: { id: 0, label: "Pending" }, // 'rejected' / 'pending' / 'approved'
                remarks: 'Incomplete documents',
                selectedScholarship: null,
            },
            scholarships: [],
            statusOptions: [
                { id: 0, label: "Pending" },
                { id: 1, label: "Approved" },
				{ id: 2, label: "Reject" },
            ],
            largeModal: false,
            submitted:false,
            json_data: [],
			json_label: {},
			json_title: "",
			messageColor: "success",
			alertMessage: "",
			showAlert: false,
			dismissCountDown: false,
			dismissCountDownS: false,
			activePage: 1,
            module: scholarship,
            columns: ["user","createdAt", "actions"],
			data: [],
			options: {
				headings: this.$lang.scholarship.table.headings,
				sortable: ['title'],
				filterable: ['title']
			}
		};
	},
	mounted() {
        let self = this;
		store.commit('showLoader', false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
	},
    watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
    methods: {
		setAlert(value) {
			this.showAlert = value;
		},
		pageChange(val) {
			this.$router.push({query: {page: val}});
		},
        viewContact(item) {
            let self = this;
            self.detail = { ...item };
            if(item.status == 0) {
                self.detail.selectedScholarship = { id: null, label: null };
                self.detail.status = { id: 0, label: "Pending" };
                self.mod = true;
            }
            if(item.status == 1) {
                self.detail.selectedScholarship = self.detail.scholarship;
                self.detail.status = { id: 1, label: "Approved" };
                self.mod = false;
            }
            if(item.status == 2) {
                self.detail.selectedScholarship = { id: null, label: null };
                self.detail.status = { id: 2, label: "Reject" };
                self.mod = false;
            }
            self.detail.remarks = item.remark;
            axios.post('scholarship/attachment/scholarship/list').then((response) => {
                self.scholarships = response.data.data;
            }).catch((error) => {
                this.scholarships = [];
            });
            self.largeModal = true;
        },
        formatLink(link) {
            if (!link) return '#' // fallback if no link
            // Add https:// if missing
            return link.startsWith('http://') || link.startsWith('https://')
            ? link
            : 'https://' + link
        },
        onSubmit() {
            let self = this;
            this.submitStatus = "PENDING";
            self.submitted = true; //Disable Button
            let postData = {};
            if(self.detail.status.id == 1) {
                postData = {                
                    id: self.detail.id,
                    status: self.detail.status.id, // 'rejected' / 'pending' / 'approved'
                    remark: self.detail.remarks,
                    scholarshipId: self.detail.selectedScholarship.id,
                };
            } else {
                postData = {                
                    id: self.detail.id,
                    status: self.detail.status.id, // 'rejected' / 'pending' / 'approved'
                    remark: self.detail.remarks,
                };
            }
            axios.post('scholarship/attachment/status', postData)
                .then(function (response) {
                self.submitted = false; //Enable Button
                if (response.data.code === 200) {
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                    self.alertMessage = response.data.response.message;
                    self.alertMessage = "success";
                    self.dismissCountDownS = 10;
                } else {
                    self.err_msg = response.data.message;
                    self.alertMessage = "danger";
                    self.dismissCountDown = 10;
                }
                })
                .catch(function (error) {
                let data;
                if (error.response.data.error) {
                    data = error.response.data.error.toString();
                } else {
                    data = error.response.data.message;
                }
                self.err_msg = data;
                self.dismissCountDown = 10;
                self.submitted = false; //Enable Button
            });
        },
    },
};
</script>

<style>
div .error {
	color: red;
}

.hasError label {
	color: red;
}
</style>